import { initMain } from "./vue/controllers/main";
import { header } from "./vue/controllers/header";

import lazyload from "./features/lazy-load";
import PresidentialElectionsFirstRound from "./vue/components/presidential-elections-first-round/PresidentialElectionsFirstRound.vue";

lazyload();
initMain([], {
  PresidentialElectionsFirstRound,
});
header();
